/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take a screenshot of the chart area. Everything runs in your browser, so your data never leaves your device.`)
};

const es_bar_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toma una captura de pantalla del área del gráfico. Todo se ejecuta en tu navegador, así que tus datos nunca salen de tu dispositivo.`)
};

const de_bar_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machen Sie einen Screenshot des Diagrammbereichs. Alles läuft in Ihrem Browser, sodass Ihre Daten Ihr Gerät nie verlassen.`)
};

const nl_bar_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een screenshot van het grafiekgebied. Alles draait in je browser, dus je data verlaat nooit je apparaat.`)
};

const fr_bar_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenez une capture d'écran de la zone du graphique. Tout s'exécute dans votre navigateur, donc vos données ne quittent jamais votre appareil.`)
};

const it_bar_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai uno screenshot dell'area del grafico. Tutto avviene nel tuo browser, quindi i tuoi dati non lasciano mai il tuo dispositivo.`)
};

const pt_br2_bar_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tire um screenshot da área do gráfico. Tudo é executado no seu navegador, então seus dados nunca saem do seu dispositivo.`)
};

const pt_bar_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tire uma captura de ecrã da área do gráfico. Tudo é executado no seu navegador, pelo que os seus dados nunca saem do seu dispositivo.`)
};

const ja_bar_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グラフ表示エリアのスクリーンショットを撮ってください。すべてブラウザ内で処理されるため、データが端末から外部に送信されることはありません。`)
};

const zh_bar_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对图表区域进行截图即可。所有操作都在你的浏览器中完成，你的数据不会离开你的设备。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_faq_a4", locale)
	if (locale === "en") return en_bar_faq_a4(inputs)
	if (locale === "es") return es_bar_faq_a4(inputs)
	if (locale === "de") return de_bar_faq_a4(inputs)
	if (locale === "nl") return nl_bar_faq_a4(inputs)
	if (locale === "fr") return fr_bar_faq_a4(inputs)
	if (locale === "it") return it_bar_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_bar_faq_a4(inputs)
	if (locale === "pt") return pt_bar_faq_a4(inputs)
	if (locale === "ja") return ja_bar_faq_a4(inputs)
	return zh_bar_faq_a4(inputs)
};